export type RoundingMode = 'round' | 'floor' | 'ceil';

/** Round a finite number to N decimal places using half-up (or floor/ceil) scaling. */
export function roundToDecimalPlaces(
  value: number,
  decimals: number,
  mode: RoundingMode = 'round',
): number {
  if (!Number.isFinite(value)) return value;
  const factor = 10 ** decimals;
  if (mode === 'floor') return Math.floor(value * factor) / factor;
  if (mode === 'ceil') return Math.ceil(value * factor) / factor;
  return Math.round(value * factor) / factor;
}
